export const STATE_PAGE = 'STATE_PAGE';
export const EXECUTE_ACCTION = 'EXECUTE_ACCTION';
export const MESSAGE = 'MESSAGE';

export const setStatePage = (payload) => ({
  type: STATE_PAGE,
  payload,
});

export const executeActions =
  ({ data, method, URL, callback, module, showNotification }) =>
  (dispatch, getState) => {
    const { statePage } = getState();
    if (data) {
      const { only, statusKey } = data;
      if (only) {
        const { dataStates } = statePage;
        if (dataStates[statusKey]) {
          if (typeof callback === 'function') {
            callback(dataStates[statusKey]);
          }
          return null;
        }
      }
    }
    const token = window.favia.getTokens();
    return dispatch({
      type: EXECUTE_ACCTION,
      payload: {
        data,
        method,
        URL,
        token,
        callback,
        module,
        showNotification,
      },
    });
  };

export const setMessage = (payload) => ({
  type: MESSAGE,
  payload,
});
